module.exports = __webpack_public_path__ + "static/media/map-icon.cdcf4619.svg";